import { Button } from "@cak-legacy/shared-common";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { FormButtons } from "../Interfaces/FormProps";

export interface IFromButtonsProps {
  buttons: FormButtons[];
  implementClickHandlers: boolean;
}

export const RenderFormButtons = (props: IFromButtonsProps) => {
  const form = useFormContext();

  return (
    <div className="formbutton-container d-print-none">
      {props.buttons.map((button) => {
        let clickHandler: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined =
          undefined;

        if (props.implementClickHandlers) {
          if (button.type === "submit") {
            clickHandler = form.handleSubmit((data: any, event: React.FormEvent) => {
              button.handle(data, event, {
                setError: (property: string, message: string, type: string) =>
                  form.setError(property, { message: message, type: type }),
                setValues: (items, shouldValidate = true) => {
                  items.forEach((value) => {
                    form.setValue(value.key, value.value, { shouldValidate });
                  });
                },
                reset: form.reset
              });
            });
          } else if (button.type === "reset") {
            clickHandler = button.handle;
          } else if (button.type === "button") {
            clickHandler = () =>
              button.handle({
                handleSubmit: (onValid, onInvalid) => form.handleSubmit(onValid, onInvalid)()
              });
          }
        }
        return (
          <Button
            key={button.id}
            id={button.id}
            buttonText={button.label}
            layout={button.layout}
            type={button.type}
            disabled={button.disabled}
            clickHandler={clickHandler}
            isLoading={button.isLoading}
          />
        );
      })}
    </div>
  );
};
